import { render } from "./payment_popup.vue?vue&type=template&id=6c8c3e3f&scoped=true"
import script from "./payment_popup.vue?vue&type=script&lang=js"
export * from "./payment_popup.vue?vue&type=script&lang=js"

import "./payment_popup.vue?vue&type=style&index=0&id=6c8c3e3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8c3e3f"]])

export default __exports__